export const SOUND_COLUMNS = [
  { key: "name", label: "Sound" },
  { key: "library", label: "Library" },
  { key: "category", label: "Category" },
  { key: "duration", label: "Duration" },
] as const;

export type SoundSortKey = typeof SOUND_COLUMNS[number]["key"];

export function soundSortValue(
  sound: { name: string; library_id: string; category: string; duration_seconds: number | null },
  key: SoundSortKey,
  libraries: ReadonlyMap<string, { name: string }>,
): string | number | null | undefined {
  switch (key) {
    case "library": return libraries.get(sound.library_id)?.name;
    case "duration": return sound.duration_seconds;
    case "category": return sound.category;
    case "name": return sound.name;
  }
}
